import ConnectorActionMenu from './ConnectorActionMenu';
import { REFRESH_ICON, TICK_ICON_INTEGRATION } from '../../utils/Constants/ClassName';
import { Box, Button, Card, Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useNotify } from 'react-admin';
import { ERROR_MESSAGES, getEnvironment } from './ConnectorConstantData';
import { useIdentityContext } from '../../components/identity';
import moment from 'moment';
import { NUMBER } from '../../utils/Constants/MagicNumber';

const currentOrigin = window.location.origin;
const environment = getEnvironment(currentOrigin);
const baseUrl = `https://protiv-${environment}-api.kiwi-internal.com`;
const apiUrl = `${baseUrl}/connector`;

// Commented code will be used in coming week.

const ConnectorCard = ({ icon, title, description, connected, connector, onConnect, onConfigure,getConnector }) => {
    const [isLoading, setIsLoading] = React.useState(false);
    // const [response, setResponse] = React.useState({});
    const notify = useNotify();
    const identity = useIdentityContext();

    const handleClickSyncData = async (connectorData) => {
        if (identity?.company_id) {
          setIsLoading(true);
          try {
            const response = await fetch(`${apiUrl}/${connectorData?.id}/autosync-connector`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                company_id: identity?.company_id,
              }),
            });
            const responseData = await response?.json();
            if (response.ok) {
              setIsLoading(false);
              notify('Data Synchronizing started.')
              getConnector()
            }else if(responseData?.details?.length){
              notify(`${ERROR_MESSAGES[responseData?.details[0]]}`)
              setIsLoading(false);
            }else {
              throw new Error('Server error');
            }
          } catch (error) {
            notify('Something went wrong: ' + error.message);
            setIsLoading(false);
          }
        }
      };

    // const checkSyncDataStatus = async (connectorData) => {
    //     if (identity?.company_id) {
    //       setIsLoading(true);
    //       try {
    //         const response = await fetch(`${apiUrl}/${connectorData?.id}/autosync-status`, {
    //           method: 'GET',
    //           headers: {
    //             'accept': 'application/json'
    //         }
    //       });
    //         if (response.ok) {
    //           const responseData = await response.json();
    //           setResponse(responseData)
    //           if(responseData && !responseData?.autosync_status){
    //             setIsLoading(true);
    //             setTimeout(()=>{
    //               checkSyncDataStatus(connectorData)
    //             },NUMBER.THIRTY_THOUSAND)
    //           }else{
    //             setIsLoading(false);
    //           }
    //         } else {
    //           throw new Error('Server error');
    //         }
    //       } catch (error) {
    //         notify('Something went wrong: ' + error.message);
    //         setIsLoading(true);
    //         checkSyncDataStatus(connectorData)
    //       }
    //     }
    //   };
    //   useEffect(() => {
    //     if(connector?.id){
    //     checkSyncDataStatus(connector);
    //     }
    //   }, [connector?.id]);

    const formattedDate = connector?.updated_at ? moment(connector?.updated_at).format('MMM D, YYYY | h:mm A') : '';

    return (
      // <Grid item md={4} sm={4} xs={12}>
      //   <div className='integration-card'>
      //     <div className='integration-card-body'>
      //       {connected && <ConnectorActionMenu />}
      //       <div className='integration-card-img'>
      //         <img src={icon} alt={title} />
      //       </div>
      //       <div className='integration-card-title'>{title}</div>
      //       <div className='not-authorized-tag'>{connected ? 'Connected' : 'Not Authorized'}</div>
      //       {/* <div className='error-desc-integration'>
      //       Error description
      //       </div> */}
      //       <p>{description}</p>
      //     </div>
      //     <div className={`integration-card-footer ${connected ? 'jobber-card-footer' : ''}`}>
      //       <Button disabled={connected} className={`${connected ? 'jobber-connected jobber-button' : 'integration-connect integration-button'}`} onClick={()=>onConnect(connector)}>
      //       {connected ? TICK_ICON_INTEGRATION() : ''} { connected ? 'connected' : 'Connect'}
      //       </Button>
      //       <Button
      //       disabled={!connected}
      //       className={`${connected ? 'jobber-configure jobber-button' : 'integration-configure integration-button'}`} onClick={()=>onConfigure(connector)}>
      //         Configure
      //       </Button>
      //     </div>
      //   </div>
      // </Grid>
      <Card
            sx={{
                p: 2,
                mt:2
            }}
            className='integration-setting-card'
        >
            <Stack
                direction={'row'}
                sx={{
                    alignItems: 'center',
                }}
                className='integration-setting-stack'
            >
                <Stack
                    sx={{
                        flex: 1,
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}
                    className='integration-stack-body'
                >
                    <img
                        src={icon}
                        alt={title}
                        loading="lazy"
                        height={100}
                        className='integration-stack-image'
                    />
                    <Stack
                        direction="column"
                        justifyContent="flex-start"
                        sx={{ marginLeft: 2 }}
                    >
                        <Typography variant="h5">
                            {title}
                        </Typography>
                    </Stack>
                </Stack>
            <div className={`integration-card-right ${connected ? 'jobber-card-right' : ''}`}>
        {connected && (isLoading ?
            <Button disabled={!connected} variant="contained" className='synchronizing-button'>
                <span className='dot-flashing'></span> Synchronizing
            </Button> :
             <Button disabled={!connected} variant="contained" className='sync-data-button' onClick={()=>handleClickSyncData(connector)}>
                {REFRESH_ICON()} Sync Data <span>{formattedDate}</span>
            </Button>)}

            {connected && <Button
            disabled={!connected}
            //  disabled={!connected || isLoading}
             className={`${connected ? 'jobber-configure jobber-button' : 'integration-configure integration-button'}`} onClick={()=>onConfigure(connector)}>
               Configure
             </Button>}
             <Button className='integration-connect integration-button' onClick={()=>onConnect(connector, !connected)}>
             {connected ? 'Disconnect' : 'Connect'}
             </Button>
           </div>
            </Stack>
        </Card>
    );
};

export default ConnectorCard;
